import { useEffect, useRef } from 'react'
import {
   default as InfiniteScroll,
   type Props,
} from 'react-infinite-scroll-component'

interface InfiniteScrollCustomProps extends Props {
   id: string
   isLoading: boolean
}

export const InfiniteScrollCustom: React.FC<InfiniteScrollCustomProps> = ({
   id,
   isLoading,
   ...props
}) => {
   const scrollableRef = useRef<HTMLDivElement>(null)

   useEffect(() => {
      const checkScrollable = () => {
         const scrollableElement = scrollableRef.current
         if (!scrollableElement || isLoading || !props.hasMore) {
            return
         }

         // Check if content height is less than or equal to container height (no scroll)
         const hasScroll =
            scrollableElement.scrollHeight > scrollableElement.clientHeight

         if (!hasScroll && props.hasMore && !isLoading) {
            // No scroll and more data available - trigger load
            props.next()
         }
      }

      // Check after a short delay to ensure DOM has updated
      const timeoutId = setTimeout(checkScrollable, 100)

      return () => clearTimeout(timeoutId)
   }, [props.dataLength, isLoading, props.hasMore, props.next, props])

   return (
      <div ref={scrollableRef} id={id} className="overflow-y-auto">
         <InfiniteScroll {...props} scrollableTarget={id} />
      </div>
   )
}
